"use client"

import * as React from "react"
import { UseFormReturn } from "react-hook-form"
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
  FormDescription,
} from "@/components/ui/form"
import { DatePicker, DatePickerProps } from "@/components/ui/date-picker"

export interface FormDatePickerProps extends Omit<DatePickerProps, "value" | "onChange"> {
  name: string
  label?: string
  description?: string
  form: UseFormReturn<any>
  required?: boolean
}

export function FormDatePicker({
  name,
  label,
  description,
  form,
  required = false,
  ...datePickerProps
}: FormDatePickerProps) {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem className="flex flex-col">
          {label && (
            <FormLabel>
              {label}
              {required && <span className="text-red-500 ml-1">*</span>}
            </FormLabel>
          )}
          <FormControl>
            <DatePicker
              value={field.value}
              onChange={field.onChange}
              {...datePickerProps}
            />
          </FormControl>
          {description && <FormDescription>{description}</FormDescription>}
          <FormMessage />
        </FormItem>
      )}
    />
  )
}